import { NewsLetterTermsModel } from "models/NewsLetter";
import { useEffect, useState } from "react";
import { newsLetterService } from "services/Services";

const NewsLetterModal = () => {
    const [terms, setTerms] = useState<NewsLetterTermsModel>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const load = async () => {
            try {
                const resp = await newsLetterService.GetTerms();
                setTerms(resp);
                console.log(resp)

                if (!resp || Object.keys(resp).length === 0){
                    setError("Kunne ikke laste vilkår.");
                }
                else{
                    setError(null);
                }
            } catch {
                setError("Kunne ikke laste vilkår.");
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    const getValidityDate = (unit?: string, amount?: number) => {
        if (!unit || typeof amount !== "number") return null;

        const now = new Date();
        switch (unit) {
            case "years": now.setFullYear(now.getFullYear() + amount); break;
            case "months": now.setMonth(now.getMonth() + amount); break;
            case "days": now.setDate(now.getDate() + amount); break;
            default: return null;
        }
        return now.toLocaleDateString("no-NO");
    };

    if (loading) return null;
    if (error || !terms){ return <div className="modal fade" id="modalNewsLetter" tabIndex={-1} role="dialog">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5">
                            Nyhetsbrev Min bedrift
                        </h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Lukk"></button>
                    </div><div className="modal-body">{error}</div></div></div></div>;}

    const attrs = terms.data?.attributes;
    const organizations = terms.included?.filter(x => x.type === "organization") ?? [];

    return (
        <div className="modal fade" id="modalNewsLetter" tabIndex={-1} role="dialog">
            <div className="modal-dialog">
                <div className="modal-content">

                    <div className="modal-header">
                        <h1 className="modal-title fs-5">
                            {attrs?.title}
                        </h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Lukk"></button>
                    </div>

                    <div className="modal-body">
                        <p className="mb-4">{attrs?.body}</p>

                        <h2 className="h5 mb-3">
                            {attrs?.processing_of_data_title ?? "Databehandling"}
                        </h2>

                        <div className="cc-traq">
                            {attrs?.purpose_html && (
                                <>
                                    <h3>{attrs?.purpose_title ?? "Formål for behandling"}</h3>
                                    <div dangerouslySetInnerHTML={{ __html: attrs.purpose_html }} />
                                </>
                            )}

                            <h3>{attrs?.personal_data_categories_title}</h3>
                            <p>{attrs?.personal_data_categories_description}</p>

                            <ul>
                                {attrs?.personal_data_categories?.map((d, i) => (
                                    <li key={i}>{d.name}</li>
                                ))}
                            </ul>

                            <h3>{attrs?.consent_valid_title}</h3>
                            <p>{getValidityDate(attrs?.validity_unit, attrs?.validity)}</p>

                            <h3>{attrs?.processing_of_data_title}</h3>
                            {attrs?.processing && (
                                <div dangerouslySetInnerHTML={{ __html: attrs.processing }} />
                            )}

                            <h3>
                                {attrs?.company_details_title ?? "Detaljer om virksomheten"}
                            </h3>

                            {organizations.map((org, idx) => (
                                <ul key={idx}>
                                    {org.attributes?.company_name && <li>{org.attributes.company_name}</li>}
                                    {org.attributes?.company_email && <li>{org.attributes.company_email}</li>}
                                    {org.attributes?.contact_phone && <li>{org.attributes.contact_phone}</li>}
                                    {org.attributes?.address_1 && <li>{org.attributes.address_1}</li>}
                                    {org.attributes?.address_2 && <li>{org.attributes.address_2}</li>}
                                </ul>
                            ))}

                            <h3>{attrs?.withdrawal_title}</h3>
                            <div dangerouslySetInnerHTML={{ __html: attrs?.withdraw_details ?? "" }} />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-light border" data-bs-dismiss="modal">Lukk vindu</button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default NewsLetterModal;